import * as types from './types';

const INITIAL_STATE = {
  grades: [],
  gradesLoading: false,
  users: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.SALES_ANALYSIS_GET_GRADES_LOADING:
      return { ...state, gradesLoading: payload };

    case types.SALES_ANALYSIS_GET_GRADES:
      const formattedGrades = payload.map(grade => {
        return {
          value: grade.Id,
          text: grade.Id + ' ' + grade.Description,
        };
      });
      formattedGrades.unshift({ value: 'ALL', text: 'ALL' });
      return { ...state, grades: formattedGrades };

    case types.SALES_ANALYSIS_REPORT_ERRORS:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/state/reducer.js